import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type {
  CartPromotionQuote,
  CartPromotionRequest,
} from "@/features/marketplace/cartPromotion";

export function useCartPromotionQuote() {
  return useMutation({
    mutationFn: (body: CartPromotionRequest) =>
      apiFetch<CartPromotionQuote>("/me/cart-promotion-quotes", {
        method: "POST",
        body: JSON.stringify(body),
      }),
  });
}
